import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { UTCModule_yyyy_MM_ddTHH_mm_ssZ } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { PortationsByContract$reflection, PortationsByContract_get_DecodeFromString } from "./Model.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { ValidatedUrlModule_value, addClientReference } from "../../HttpV2.js";
import { HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { string_type, equals } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { memoize } from "../../Utils.js";

function loadPortations$0027$0027(clientNr, contractNr, fromDate, toDate) {
    let arg_3, arg_2;
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, (arg_3 = UTCModule_yyyy_MM_ddTHH_mm_ssZ(toDate), (arg_2 = UTCModule_yyyy_MM_ddTHH_mm_ssZ(fromDate), toText(printf("/Telecom/Portations/%i/%i/%s/%s"))(clientNr)(contractNr)(arg_2)(arg_3)))));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const customDecoder = PortationsByContract_get_DecodeFromString();
        const caseStrategy_1 = defaultArg(void 0, new CaseStrategy(0));
        const parseFn = PortationsByContract_get_DecodeFromString();
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(PortationsByContract$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

const loadPortations$0027 = memoize((tupledArg) => loadPortations$0027$0027(tupledArg[0], tupledArg[1], tupledArg[2], tupledArg[3]));

export function loadPortations(clientNr, contractNr, fromDate, toDate) {
    return loadPortations$0027([clientNr, contractNr, fromDate, toDate]);
}

